import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// PrimeNG modules
import { ButtonModule } from 'primeng/button';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { DialogModule } from 'primeng/dialog';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { AvatarModule } from 'primeng/avatar';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

// Shared Module
import { SharedModule } from '../../shared/shared.module';

// Components
import { CommentsComponent } from './components/comments/comments.component';

// Services
import { CommentsService } from './services/comments.service';

@NgModule({
  declarations: [
    CommentsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    ButtonModule,
    InputTextareaModule,
    DialogModule,
    ScrollPanelModule,
    AvatarModule,
    TooltipModule,
    ConfirmDialogModule
  ],
  providers: [
    // CommentsService - Removed, provided in root via @Injectable
  ],
  exports: [
    CommentsComponent
  ]
})
export class CommentsModule { }
